import { supabase } from "@/integrations/supabase/client";

export async function hasActiveSubscription(userId: string): Promise<boolean> {
  const { data } = await supabase
    .from("subscriptions")
    .select("status")
    .eq("user_id", userId)
    .eq("status", "active")
    .gt("ends_at", new Date().toISOString())
    .limit(1);

  return Boolean(data && data.length > 0);
}
